import Header from "../components/Header"
import Footer from "../components/Footer"
import Breadcrumb from "../components/Breadcrumb"
import LazyLoad from "react-lazyload"
const Library = () => {
    return (
        <>
            <Header />
            <Breadcrumb mid="Facilities" breadcrumbName="Library" />

            <div className="innerSection">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h1>Library</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <p>The school has a well furnished library and caters to the need of the students with regard to literary books as well as books related to academics. The teachers also get reference books in the respective subjects.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                             
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library1.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                              
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library2.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                              
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library3.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                                 
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library4.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                                
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library5.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                          
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div class="labs-box">
                                <LazyLoad><img src="https://webapi.entab.info/api/image/SMSMU/public/Images/Library6.jpg"  alt="St Mary School, Mirzapur" className="img-fluid" /></LazyLoad>
                       
                            </div>
                        </div>

                   
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Library